export default __webpack_public_path__ + "static/media/imgBowl.14f81297.png";